import { render, staticRenderFns } from "./EditFileDevisDialog.vue?vue&type=template&id=1f0b70c8"
import script from "./EditFileDevisDialog.vue?vue&type=script&lang=js"
export * from "./EditFileDevisDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports